@if (component?.block && variant) {
<cms-outlet-block [variant]="variant"
                  [disallow]="[ID]" />
}